import { Organization } from "@models/Organization";
import ListadoUsuarios from "@components/Configuracion/Usuarios/ListadoUsuarios";
import { TabDetailScreenWrapper } from "@components/General/TabDetailScreen";
import ListadoRoles from "@components/Configuracion/Usuarios/ListadoRoles";
import { useState } from "react";

interface ConfiguracionUsuariosProps {
    org: Organization;
}


const ConfiguracionUsuarios: React.FC<ConfiguracionUsuariosProps> = ({org}) => {
    const [screen, setScreen] = useState<'usuarios' | 'roles'>('usuarios');

    return (
        <TabDetailScreenWrapper
            title="Configuracion"
            flag={org.newFlags.AdminUserCreationWeb}
            clickedScreen={screen}
            setClickedScreen={(screen) => {
                setScreen(screen as 'usuarios' | 'roles');
            }}
            flaps={[{
                id: 'usuarios',
                label: 'Usuarios',
                content: <ListadoUsuarios org={org} />,
            },
            {
                id: 'roles',
                label: 'Roles',
                content: <ListadoRoles org={org} />,
            }]}
            subtitle="Gestiona la configuración de tu organización"
        />
    );
}

export { ConfiguracionUsuarios };
